import React from 'react'
import styled from 'styled-components'

const Thumb = styled.div`
  width: 26px;
  height: 26px;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.toggleSwitch.thumbColour};
  border: 8.5px solid ${({ theme }) => theme.toggleSwitch.thumbBorderColour};
  border-radius: 100%;
  margin-left: 0;
  transition: transform 90ms ease-in-out;
  filter: drop-shadow(0px 6px 10px rgba(0, 0, 0, 0.12));
`

const Wrapper = styled.div`
  width: 60px;
  height: 30px;
  box-sizing: border-box;
  padding: 2px;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.toggleSwitch.colour};
  border-radius: 30px;
  transition: background-color 200ms ease-in-out;

  :focus-within,
  :has(input:active),
  :hover {
    outline: 2px solid black;
  }
  :has(input:active) {
    background-color: ${({ theme }) => theme.toggleSwitch.activeColour};
  }
  :has(input:checked) {
    background-color: ${({ theme }) => theme.toggleSwitch.checkedColour};
    > ${Thumb} {
      transform: translate(30px);
    }
  }
  :has(input:active:checked) {
    background-color: ${({ theme }) => theme.toggleSwitch.checkedActiveColour};
  }
  > input {
    opacity: 0;
    position: absolute;
    left: -9999em;
  }
`

export function ToggleSwitch(
  props: Omit<
    React.DetailedHTMLProps<
      React.InputHTMLAttributes<HTMLInputElement>,
      HTMLInputElement
    >,
    'type'
  >,
) {
  return (
    <Wrapper>
      <Thumb />
      <input {...props} type='checkbox' />
    </Wrapper>
  )
}
